import { includes, toLower } from 'lodash/fp';

const getIsMatch = (searchTerm: string, location: string) => includes(toLower(searchTerm), toLower(location));

export default getIsMatch;
